import { render, staticRenderFns } from "./SubFleet.vue?vue&type=template&id=4be8a3a4&scoped=true&"
import script from "./SubFleet.vue?vue&type=script&lang=js&"
export * from "./SubFleet.vue?vue&type=script&lang=js&"
import style0 from "./SubFleet.vue?vue&type=style&index=0&id=4be8a3a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be8a3a4",
  null
  
)

export default component.exports